
import zhizhen from '@/assets/zanzanwodeguo/zhuanpan-zhizhen.png'
import zhizhenGray from '@/assets/zanzanwodeguo/zhuanpan-zhizhen-gray.png'
import openbg from '@/assets/jifenhuangou/lottery/popup-bg.png'
import { getRequest } from '@/libs/utils.js'
import { getaddlog } from '@/api/hgfw'
import { award, isAward, getExam } from '@/api/lottery'
import { getAddressDefault } from '@/api/user'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'

import { addCreditParty, addAddress, relation, view, addPartyCount } from '@/api/jfhl.js'
import { updateuser, getUserItem } from '@/api/lottery.js'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XInput,
XButton,
Group
},
data () {
return {
zhizhen: zhizhen,
times: '', // 答题次数
lotid: 0,
showOpen: false,
openbg: openbg,
prize: '',
start_rotating_degree: 0, // 初始旋转角度
rotate_angle: 0, // 将要旋转的角度
rotate_transition: 'transform 6s ease-in-out', // 初始化选中的过度属性控制
rotate_transition_pointer: 'transform 10s ease-in-out', // 初始化指针过度属性控制
click_flag: true, // 是否可以旋转抽奖
partyid: this.$route.params.partyid,
partyuserid: this.$route.params.partyuserid,
prizelist: [], // 奖品列表
isAward: 1, // 是否中奖
angle: '', // 转动角度
jiangpin: '', // 抽中奖品
first: true,
isgo: true
}
},
created () {
this.getAdd()
this.getview()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
gorule () {
this.$router.push({ name: 'fangyiRule' })
},
getAdd () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120105
}).then(res => {
})
},
getview () {
view({
id: this.partyid
}).then(res => {
this.lotid = res.obj.lotid
this.getWinning()
this.isawardNow()
})
},
go () {
this.isgo = false

if (this.isAward !== 2 && this.first) {
this.isaward()
}
},

isawardNow () {
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.obj.iszhongjiang === 1) {
this.zhizhen = zhizhenGray
this.isAward = 2
this.$vux.toast.text('您已经中过奖了！')
} else {
if (data.obj.isaward === 1) {
this.zhizhen = zhizhenGray
this.isAward = 2
this.$vux.toast.text('您今天的抽奖次数已经用完！')
} else {
this.isgo = true
this.zhizhen = zhizhen
this.first = true
}
}
})
},

isaward () {
award({
lotid: this.lotid,
openid: this.userid,
partyuserid: this.partyuserid
}).then(data => {
if (data.success) {
this.isAward = data.obj.isaward
if (data.obj.isaward != 2) {
this.isgo = true
this.angle = data.obj.angle
this.prize = data.obj.item
if (data.obj.item.indexOf('积分') != -1) {
this.addIntegral(data.obj.item.replace(/[^0-9]/ig, ''))
}
this.first = false
this.rotating(parseInt(this.angle))

relation({
partyuserid: this.partyuserid,
lotid: this.lotid,
userid: this.accountid,
openid: this.userid
}).then(data => { })
} else {
this.isgo = false
this.$vux.toast.text('您已经抽过奖了')
this.zhizhen = zhizhenGray
}
}
})
},
rotating (degree) {
if (!this.click_flag) return
var type = 0 
var during_time = 5 
var rand_circle = 6 
this.click_flag = false 
if (type == 0) {

var rotate_angle = this.start_rotating_degree + (360 - this.start_rotating_degree % 360) + rand_circle * 360 + degree 
this.start_rotating_degree = rotate_angle
this.rotate_angle = 'rotate(' + rotate_angle + 'deg)'
var that = this

setTimeout(() => {
this.click_flag = true
this.winning()
}, during_time * 1000)
}
},
getWinning () {
getUserItem({
openid: this.userid,
lotid: this.lotid
}).then(res => {
this.prizelist = res.obj.items
})
},
winning () {
setTimeout(() => {
this.showOpen = true
}, 2000)
},
close () {
this.showOpen = false
this.zhizhen = zhizhenGray
this.isAward = 2
this.getWinning()
},
addIntegral (credit) {
addCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
type: 1
}).then(res => {
})
}
}
}
